import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
export function map(arg0, arg1, arg2) {
  var target;
  var filter;
  var instructions;
  if (typeof arg1 === "undefined" && typeof arg2 === "undefined") {
    target = {};
    instructions = arg0;
  } else {
    target = arg0;
    if (typeof arg1 === "function") {
      filter = arg1;
      instructions = arg2;
      return mapWithFilter(target, filter, instructions);
    } else {
      instructions = arg1;
    }
  }
  for (var _i = 0, _Object$keys = Object.keys(instructions); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    if (!Array.isArray(instructions[key])) {
      target[key] = instructions[key];
      continue;
    }
    applyInstruction(target, null, instructions, key);
  }
  return target;
}
export var convertMap = function convertMap(target) {
  var output = {};
  for (var _i2 = 0, _Object$entries = Object.entries(target || {}); _i2 < _Object$entries.length; _i2++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
      k = _Object$entries$_i[0],
      v = _Object$entries$_i[1];
    output[k] = [, v];
  }
  return output;
};
export var take = function take(source, instructions) {
  var out = {};
  for (var key in instructions) {
    applyInstruction(out, source, instructions, key);
  }
  return out;
};
var mapWithFilter = function mapWithFilter(target, filter, instructions) {
  return map(target, Object.entries(instructions).reduce(function (_instructions, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (Array.isArray(value)) {
      _instructions[key] = value;
    } else {
      if (typeof value === "function") {
        _instructions[key] = [filter, value()];
      } else {
        _instructions[key] = [filter, value];
      }
    }
    return _instructions;
  }, {}));
};
var applyInstruction = function applyInstruction(target, source, instructions, targetKey) {
  if (source !== null) {
    var instruction = instructions[targetKey];
    if (typeof instruction === "function") {
      instruction = [, instruction];
    }
    var _instruction = instruction,
      _instruction2 = _slicedToArray(_instruction, 3),
      _instruction2$ = _instruction2[0],
      _filter = _instruction2$ === void 0 ? nonNullish : _instruction2$,
      _instruction2$2 = _instruction2[1],
      valueFn = _instruction2$2 === void 0 ? pass : _instruction2$2,
      _instruction2$3 = _instruction2[2],
      sourceKey = _instruction2$3 === void 0 ? targetKey : _instruction2$3;
    if (typeof _filter === "function" && _filter(source[sourceKey]) || typeof _filter !== "function" && !!_filter) {
      target[targetKey] = valueFn(source[sourceKey]);
    }
    return;
  }
  var _instructions$targetK = _slicedToArray(instructions[targetKey], 2),
    filter = _instructions$targetK[0],
    value = _instructions$targetK[1];
  if (typeof value === "function") {
    var _value;
    var defaultFilterPassed = filter === undefined && (_value = value()) != null;
    var customFilterPassed = typeof filter === "function" && !!filter(void 0) || typeof filter !== "function" && !!filter;
    if (defaultFilterPassed) {
      target[targetKey] = _value;
    } else if (customFilterPassed) {
      target[targetKey] = value();
    }
  } else {
    var _defaultFilterPassed = filter === undefined && value != null;
    var _customFilterPassed = typeof filter === "function" && !!filter(value) || typeof filter !== "function" && !!filter;
    if (_defaultFilterPassed || _customFilterPassed) {
      target[targetKey] = value;
    }
  }
};
var nonNullish = function nonNullish(_) {
  return _ != null;
};
var pass = function pass(_) {
  return _;
};